import { render } from "./ExpertStatisticsThirdPartyNumber.vue?vue&type=template&id=6627b1cb"
import script from "./ExpertStatisticsThirdPartyNumber.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsThirdPartyNumber.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__